export const fullUrl = (uri: string) => {
  return !uri.startsWith('http') ? `https://api.nxgqt.org${uri}` : uri
}
